import * as React from 'react';
export const Rss = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M4.657 22.497a2.907 2.907 0 100-5.813 2.907 2.907 0 000 5.813z" />
    <path d="M1.75 1.75v3.773c9.373 0 16.973 7.6 16.973 16.974h3.774c0-11.454-9.294-20.747-20.747-20.747zm0 7.547v3.773c5.2 0 9.427 4.227 9.427 9.427h3.773c0-7.294-5.907-13.2-13.2-13.2z" />
  </svg>
);
